export default __webpack_public_path__ + "static/media/pu1.eb120d34.png";